"use client";

/**
 * FullScreenSpinner — shared full-screen loading indicator used by the
 * dashboard chrome layout, the /o resolver, and the /o/[org] layout guard.
 *
 * Markup is intentionally identical across all three sites — DRY replacement
 * of the three previously inline `LoadingSpinner` / `OrgLoadingSpinner` blocks.
 */
export default function FullScreenSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <div className="flex flex-col items-center gap-3">
        <svg
          className="h-6 w-6 animate-spin text-brand-600"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="3"
            className="opacity-25"
          />
          <path
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            fill="currentColor"
            className="opacity-75"
          />
        </svg>
        <p className="text-sm text-slate-400">Loading...</p>
      </div>
    </div>
  );
}
